module.exports = __webpack_public_path__ + "static/media/DancingScript-VariableFont_wght.d58bb592.ttf";